import React from 'react';
import { Users, ShieldCheck, MapPin, Clock } from 'lucide-react';

const items = [
  { Icon: Users, value: '28,000+', label: 'Sellers Served' },
  { Icon: ShieldCheck, value: '96%', label: 'GST Approval Rate' },
  { Icon: MapPin, value: '30+', label: 'Locations Covered' },
  { Icon: Clock, value: '24hr', label: 'Response Time' },
];

const StatsStrip = () => (
  <section className="bg-white border-y border-black/5" data-testid="stats-strip">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-8 md:py-10 grid grid-cols-2 md:grid-cols-4 gap-6">
      {items.map(({ Icon, value, label }) => (
        <div key={label} className="flex items-center gap-3 md:gap-4">
          <div className="w-11 h-11 rounded-full bg-[#F39200]/10 text-[#F39200] flex items-center justify-center shrink-0">
            <Icon size={20} />
          </div>
          <div>
            <div className="text-2xl md:text-3xl font-extrabold text-neutral-900 leading-none">{value}</div>
            <div className="text-xs md:text-sm text-neutral-500 mt-1">{label}</div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default StatsStrip;
